import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to top when navigating between routes.
 *
 * Behaviour:
 * - On pathname change without a hash, scrolls to top.
 * - If there is a hash (e.g. "/#about"), do nothing here and let the destination page handle in-page scrolling.
 * - Disables browser native scroll restoration to avoid restoring previous positions on route changes.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  // Disable browser scroll restoration
  useEffect(() => {
    const browserWindow = globalThis.window;

    if (browserWindow && 'scrollRestoration' in browserWindow.history) {
      try {
        browserWindow.history.scrollRestoration = 'manual';
      } catch {
        // Intentionally ignore errors for scrollRestoration
      }
    }
  }, []);

  // Scroll to top on route change (when not using an in-page hash)
  useEffect(() => {
    if (!hash) {
      const browserWindow = globalThis.window;

      browserWindow?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
